import React, { useState } from "react";
import {
  GeneralStyle,
  LowerWrapper,
  SelectsSection,
} from "./HighAlertQuestionBlock.styled";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import { ValidationTextStyle } from "../FormsManagement/FormFilling/FormFilling.styled";

const HighAlertQuestionBlock = ({
  preview = true,
  setHighPriorityReason,
  setHighPriority,
  showError,
}) => {
  const [check, setCheck] = useState(false);
  const [reason, setReason] = useState("");
  return (
    <>
      <GeneralStyle>
        <LowerWrapper>
          <SelectsSection>
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    name="alert-check"
                    onChange={(e) => {
                      setCheck(e.target.checked);
                      if (!preview) {
                        setHighPriority(e.target.checked);
                      }
                    }}
                  />
                }
                style={{ textAlign: "center", width: "100%" }}
                label="Select as High Alert"
              />
              {check && (
                <textarea
                  type="text"
                  placeholder="Enter your reason for High Alert here"
                  value={reason}
                  onChange={(e) => {
                    setReason(e.target.value);
                    if (!preview) {
                      setHighPriorityReason(e.target.value);
                    }
                  }}
                ></textarea>
              )}
              {showError && (
                <ValidationTextStyle>
                  Please enter the reason
                </ValidationTextStyle>
              )}
            </div>
          </SelectsSection>
        </LowerWrapper>
      </GeneralStyle>
    </>
  );
};

export default HighAlertQuestionBlock;
